/*
  Aimer Atacado — landing "Entrar" (v2).
  Sem dependências. Tudo é progressivo: sem JS a página continua inteira
  (o conteúdo só fica escondido para revelar quando a classe .ae-js existe).
*/
(function () {
  if (window.__aimerEntrar) return;
  window.__aimerEntrar = true;

  var doc = document;
  var root = doc.documentElement;
  var reduzido = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  root.classList.add('ae-js');

  function pronto(fn) {
    if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  /* ------------------------------------------------ Revelação ao rolar */
  // Checagem por posição na rolagem (e não IntersectionObserver): é barata
  // para ~40 itens e não depende de o navegador disparar o observer.
  var pendentes = [];

  function iniciarRevelacao() {
    pendentes = [].slice.call(doc.querySelectorAll('.ae-reveal'));
    if (reduzido) {
      pendentes.forEach(function (el) {
        el.classList.add('is-visivel');
      });
      pendentes = [];
    }
  }

  function revelarVisiveis(vh) {
    if (!pendentes.length) return;
    pendentes = pendentes.filter(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < vh * 0.92 && r.bottom > -40) {
        el.classList.add('is-visivel');
        return false;
      }
      // o que já ficou para trás (âncora, recarregar no meio) aparece direto
      if (r.bottom <= -40) {
        el.classList.add('is-visivel');
        return false;
      }
      return true;
    });
  }

  /* -------------------- Barra do topo, CTA fixo, marca d'água, galeria */
  function iniciarRolagem() {
    var topo = doc.querySelector('[data-ae-topo]');
    var fixo = doc.querySelector('[data-ae-fixo]');
    var hero = doc.querySelector('[data-ae-hero]');
    var cadastro = doc.getElementById('cadastro');
    var marcas = [].slice.call(doc.querySelectorAll('[data-ae-parallax]'));
    var agendado = false;

    function atualizar() {
      agendado = false;
      var y = window.pageYOffset || root.scrollTop || 0;
      var vh = window.innerHeight;

      if (topo) topo.classList.toggle('is-rolando', y > 8);
      revelarVisiveis(vh);

      if (fixo) {
        var passouHero = hero ? hero.getBoundingClientRect().bottom < 80 : y > 500;
        var noCadastro = false;
        if (cadastro) {
          var r = cadastro.getBoundingClientRect();
          noCadastro = r.top < vh * 0.85 && r.bottom > 0;
        }
        var ativo = passouHero && !noCadastro;
        fixo.classList.toggle('is-ativo', ativo);
        fixo.setAttribute('aria-hidden', ativo ? 'false' : 'true');
        [].forEach.call(fixo.querySelectorAll('a'), function (a) {
          a.tabIndex = ativo ? 0 : -1;
        });
      }

      if (!reduzido) {
        marcas.forEach(function (el) {
          var r = el.parentNode.getBoundingClientRect();
          if (r.bottom < 0 || r.top > vh) return;
          el.style.transform = 'translate3d(0,' + Math.round((r.top - vh / 2) * -0.12) + 'px,0)';
        });
      }
    }

    // setTimeout (e não rAF): rAF não dispara em abas sem pintura.
    function aoRolar() {
      if (agendado) return;
      agendado = true;
      setTimeout(atualizar, 60);
    }

    window.addEventListener('scroll', aoRolar, { passive: true });
    window.addEventListener('resize', aoRolar, { passive: true });
    window.addEventListener('load', aoRolar);
    atualizar();
  }

  function iniciarGaleria() {
    [].forEach.call(doc.querySelectorAll('[data-ae-galeria]'), function (galeria) {
      var trilho = galeria.querySelector('[data-ae-trilho]');
      var barra = galeria.querySelector('[data-ae-progresso]');
      if (!trilho || !barra) return;
      var t;
      function mover() {
        var max = trilho.scrollWidth - trilho.clientWidth;
        var p = max > 0 ? trilho.scrollLeft / max : 0;
        var pista = barra.parentNode.clientWidth - barra.clientWidth;
        barra.style.transform = 'translateX(' + (p * pista).toFixed(1) + 'px)';
      }
      trilho.addEventListener(
        'scroll',
        function () {
          clearTimeout(t);
          t = setTimeout(mover, 16);
        },
        { passive: true }
      );
      mover();
    });
  }

  /* -------------------------------------------------------------- Vídeo */
  function lerFontes(palco) {
    var el = palco.querySelector('[data-ae-video-fontes]');
    var lista = [];
    try {
      lista = JSON.parse(el.textContent) || [];
    } catch (e) {}
    var mp4 = lista
      .filter(function (f) {
        return f.format === 'mp4' && f.url;
      })
      .sort(function (a, b) {
        return (a.height || 0) - (b.height || 0);
      });
    var hls = lista.filter(function (f) {
      return f.format === 'm3u8' && f.url;
    })[0];
    return { mp4: mp4, hls: hls ? hls.url : '' };
  }

  function escolherFonte(palco) {
    var f = lerFontes(palco);
    var fallback = palco.dataset.fallback || '';
    var teste = doc.createElement('video');
    var tocaHls =
      f.hls &&
      (teste.canPlayType('application/vnd.apple.mpegurl') || teste.canPlayType('application/x-mpegURL'));

    var con = navigator.connection || {};
    var lenta = con.saveData || /(^|-)2g|3g/.test(con.effectiveType || '');
    var melhor = f.mp4.length ? f.mp4[f.mp4.length - 1].url : fallback;
    var mp4 = lenta && fallback ? fallback : melhor;

    if (tocaHls) return { src: f.hls, tipo: 'application/x-mpegURL', reserva: mp4 };
    return { src: mp4, tipo: 'video/mp4', reserva: '' };
  }

  function iniciarVideo() {
    [].forEach.call(doc.querySelectorAll('[data-ae-video]'), function (palco) {
      var capa = palco.querySelector('[data-ae-video-capa]');
      if (!capa) return;
      capa.addEventListener('click', function () {
        var d = palco.dataset;
        var fonte = escolherFonte(palco);
        if (!fonte.src) return;

        var video = doc.createElement('video');
        video.controls = true;
        video.playsInline = true;
        video.setAttribute('playsinline', '');
        video.preload = 'auto';
        if (d.poster) video.poster = d.poster;
        if (d.titulo) video.setAttribute('aria-label', d.titulo);

        var source = doc.createElement('source');
        source.src = fonte.src;
        source.type = fonte.tipo;
        video.appendChild(source);

        // Se o HLS falhar por qualquer motivo, cai para o MP4.
        if (fonte.reserva) {
          source.addEventListener('error', function () {
            video.removeChild(source);
            video.src = fonte.reserva;
            video.play().catch(function () {});
          });
        }

        capa.parentNode.replaceChild(video, capa);
        video.focus({ preventScroll: true });
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      });
    });
  }

  /* ------------------------------ Acabamento do Shopify Forms (shadow DOM) */
  var CSS_FORMS = [
    ':host{display:block;width:100%}',
    '[class*="_formHeader_"]{display:none!important}',
    '[class*="_formContainer_"],[class*="_inline_"]{max-width:100%!important;width:100%!important;background:transparent!important;box-shadow:none!important}',
    '[class*="_gridItemContent_"]{padding:0!important}',
    'form{gap:14px!important}',
    'input,[class*="_selectToggle_"]{font-family:"Jost",Assistant,sans-serif!important;font-size:16px!important;color:#4a3b32!important}',
    'label,[class*="_label_"]{font-family:"Jost",Assistant,sans-serif!important;color:rgba(74,59,50,.72)!important;letter-spacing:.02em}',
    'input:focus-visible,[class*="_selectToggle_"]:focus-visible{outline:none!important}',
    '[data-testid="btn-form-submit"]{justify-content:center;align-items:center;font-family:"Jost",Assistant,sans-serif!important;font-size:16px!important;font-weight:500!important;letter-spacing:.06em!important;text-transform:none;box-shadow:0 10px 24px -12px rgba(143,74,53,.65);transition:background .25s ease,transform .25s ease!important;cursor:pointer}',
    '[data-testid="btn-form-submit"]:hover{background:#9d573f!important;filter:none!important;opacity:1!important}',
    '[data-testid="btn-form-submit"]:active{transform:scale(.985)}',
    '[data-testid="btn-form-submit"]:focus-visible{outline:2px solid #b4654a!important;outline-offset:3px!important}',
    '.phone-country-selector button{min-height:59px!important;box-sizing:border-box!important;align-items:center!important}',
    '[class*="_formDisclaimer_"]{margin-top:14px!important}',
    '[class*="_formDisclaimer_"] p{font-family:"Jost",Assistant,sans-serif!important;font-size:12.5px!important;line-height:1.55!important;color:rgba(74,59,50,.62)!important;text-align:center}',
    '[class*="_textHeading_"]{font-family:"Cormorant Garamond",Georgia,serif!important;font-weight:500!important;color:#4a3b32!important}',
    '[class*="_textBody_"]{font-family:"Jost",Assistant,sans-serif!important}'
  ].join('');

  function vestirForms() {
    var area = doc.querySelector('[data-ae-forms]');
    if (!area) return;
    var rotulo = area.getAttribute('data-ae-forms-botao');
    var tentativas = 0;

    function aplicar() {
      var host = area.querySelector('shopify-forms-embed');
      var sr = host && host.shadowRoot;
      if (!sr) return false;

      if (!sr.querySelector('style[data-ae]')) {
        var st = doc.createElement('style');
        st.setAttribute('data-ae', '');
        st.textContent = CSS_FORMS;
        sr.appendChild(st);
      }

      var botao = sr.querySelector('[data-testid="btn-form-submit"]');
      if (botao && rotulo && botao.textContent.trim() === 'Enviar') botao.textContent = rotulo;
      return !!botao;
    }

    var timer = setInterval(function () {
      tentativas += 1;
      if (aplicar() || tentativas > 60) clearInterval(timer);
    }, 250);
  }

  /* ---------------------------------- Máscaras do formulário nativo */
  function iniciarFormNativo() {
    var form = doc.getElementById('aimer-candidatura');
    if (!form) return;

    function mascTelefone(v) {
      v = v.replace(/\D/g, '').slice(0, 11);
      if (v.length <= 2) return v.length ? '(' + v : '';
      if (v.length <= 6) return '(' + v.slice(0, 2) + ') ' + v.slice(2);
      if (v.length <= 10) return '(' + v.slice(0, 2) + ') ' + v.slice(2, 6) + '-' + v.slice(6);
      return '(' + v.slice(0, 2) + ') ' + v.slice(2, 7) + '-' + v.slice(7);
    }

    function mascDoc(v) {
      v = v.replace(/\D/g, '').slice(0, 14);
      if (v.length <= 11) {
        return v
          .replace(/^(\d{3})(\d)/, '$1.$2')
          .replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
          .replace(/\.(\d{3})(\d{1,2})$/, '.$1-$2');
      }
      return v
        .replace(/^(\d{2})(\d)/, '$1.$2')
        .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
        .replace(/\.(\d{3})(\d)/, '.$1/$2')
        .replace(/(\d{4})(\d{1,2})$/, '$1-$2');
    }

    [].forEach.call(form.querySelectorAll('[data-aimer-mask]'), function (input) {
      var fn = input.dataset.aimerMask === 'phone' ? mascTelefone : mascDoc;
      input.addEventListener('input', function () {
        input.value = fn(input.value);
      });
    });

    // Os campos extras não são aceitos pelo formulário nativo de cliente da
    // Shopify, então viram uma nota estruturada no cadastro da candidata.
    form.addEventListener('submit', function () {
      var nota = doc.getElementById('aimer-note');
      if (!nota) return;
      var partes = [];
      [].forEach.call(form.querySelectorAll('[data-aimer-extra]'), function (campo) {
        if (campo.value) partes.push(campo.dataset.aimerExtra + ': ' + campo.value);
      });
      nota.value = partes.join(' | ');
    });
  }

  pronto(function () {
    iniciarRevelacao();
    iniciarRolagem();
    iniciarGaleria();
    iniciarVideo();
    vestirForms();
    iniciarFormNativo();
  });
})();
